import { IUserPlayer } from "@grassrootly/api";
import { Button, Div, FormBuilder } from "@grassrootly/rn-core";
import { useEditProfile } from "./useEditProfile";
import { images } from "../../layout/assets";
import { ImagePicker } from "../../components/image-picker";
import { EditProfileProps } from "./Profile.types";

export default function EditProfile({ player, onEditFinished }: EditProfileProps) {
  const { profileFormState, onSubmitEdit, onNewImagePicked, newImage, onUploadCancel, updating } = useEditProfile({
    player,
    onEditFinished,
  });
  return (
    <Div classNames={["flex1"]}>
      <ImagePicker
        onPicked={onNewImagePicked}
        classNames={["mr-{auto}", "ml-{auto}"]}
        resizeMode="cover"
        onCancel={newImage ? onUploadCancel : undefined}
        source={
          newImage
            ? { uri: newImage.uri }
            : player.profile_picture
            ? { uri: player.profile_picture }
            : images.playerAvatar
        }
        base64
      />
      <Div classNames={["flex1", "w100", "mt-{24}"]}>
        {profileFormState ? (
          <FormBuilder
            form={profileFormState}
            onSubmit={onSubmitEdit}
            submitControl={(submit) => (
              <Button
                title="Save"
                classNames={["btnBlock", "mt-{24}"]}
                isLoading={updating}
                disabled={updating}
                type="button"
                onPress={submit}
              />
            )}
          />
        ) : null}
      </Div>
    </Div>
  );
}
